// Entry — mounts <App /> into #root. styles.css carries the Westfert design
// system (light default + [data-theme="dark"]); reveal.js adds scroll-in
// animations as a progressive enhancement (disabled under reduced motion).

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./styles.css";
import "./lib/reveal.js";
import App from "./App.jsx";

// Theme boot: light is the default; the Topbar toggle persists the choice.
document.documentElement.dataset.theme = localStorage.getItem("pa_theme") || "light";
// The design system ships three visual directions; "vibrant" is the approved one.
document.documentElement.dataset.dir = "vibrant";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
